import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import SignaturePadComponent, {
  SignaturePadRef,
} from "../Add Risk Assessment/SignaturePadComponent";

interface SignaturesProps {
  users: any[];
  formValues: any;
  setFormValues: any;
  usersRefs: React.RefObject<SignaturePadRef>[];
  isPermitSpaceFormAttached: boolean;
  textToShow: string;
  setPermitFiles: any;
  isStandaloneMode: any;
  type: string;
}

const PermitSignaturesComponent: React.FC<SignaturesProps> = ({
  users,
  formValues,
  setFormValues,
  usersRefs,
  isPermitSpaceFormAttached,
  textToShow,
  setPermitFiles,
  isStandaloneMode,
  type,
}) => {
  // Memoize the component to prevent unnecessary re-renders
  const memoizedMembers = React.useMemo(() => users, [users]);

  // // Effect to check and copy signatures from DRA form refs if they exist
  // React.useEffect(() => {
  //   memoizedMembers.forEach((member, index) => {
  //     const ref = usersRefs[index];
  //     if (ref?.current && !ref.current.isEmpty()) {
  //       // Signature exists in DRA form, trigger the onEnd callback to update form values
  //       setFormValues((prev: any) => ({
  //         ...prev,
  //         users: prev.users.map((tm: any, i: number) =>
  //           i === index
  //             ? { ...tm, signatureDate: new Date().toISOString() }
  //             : tm
  //         ),
  //       }));
  //     }
  //   });
  // }, [memoizedMembers, usersRefs, setFormValues]);

  return (
    <div className="tw-w-full tw-mt-6">
      <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 sm:tw-gap-6 tw-w-full">
        {/* Users Signatures */}
        {memoizedMembers.map((member, index) => (
          <div
            key={member.userID}
            className="tw-flex tw-flex-col tw-items-start tw-w-full"
          >
            <span className="tw-mb-2 tw-mt-4 tw-text-sm sm:tw-text-base tw-font-medium">
              {member.displayName}
            </span>
            <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
              <div className="tw-w-full tw-min-h-[120px] tw-border tw-border-gray-300 tw-rounded">
                <SignaturePadComponent
                  ref={usersRefs[index]}
                  penColor="black"
                  onEnd={() => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      users: prev.users.map((tm: any, i: number) =>
                        i === index
                          ? { ...tm, signatureDate: new Date().toISOString() }
                          : tm
                      ),
                    }));
                  }}
                />
              </div>
              <Button
                label="Clear"
                onClick={() => {
                  usersRefs[index]?.current?.clear();
                  if (!isStandaloneMode) {
                    setPermitFiles((prev: any) => ({
                      ...prev,
                      [type]: prev[type].filter(
                        (item: any) => item.userID !== member.userID
                      ),
                    }));
                  }
                }}
                className="tw-mt-2 focus:tw-shadow-none tw-bg-[#152846] tw-text-white tw-px-3 sm:tw-px-4 tw-py-1 sm:tw-py-2 tw-rounded-full tw-text-xs sm:tw-text-sm"
              />
            </div>
            <InputText
              type="text"
              value={
                formValues.entrantTopmans[type].find(
                  (item: any) => item.userID === member.userID
                )?.value || ""
              }
              readOnly={isPermitSpaceFormAttached}
              onChange={(e) => {
                const newValue = e.target.value;
                setFormValues((prev: any) => {
                  const exists = prev.entrantTopmans[type].some(
                    (item: any) => item.userID === member.userID
                  );
                  return {
                    ...prev,
                    entrantTopmans: {
                      ...prev.entrantTopmans,
                      [type]: exists
                        ? prev.entrantTopmans[type].map((item: any) =>
                            item.userID === member.userID
                              ? { ...item, value: newValue }
                              : item
                          )
                        : [
                            ...prev.entrantTopmans[type],
                            {
                              userID: member.userID,
                              value: newValue,
                            },
                          ],
                    },
                  };
                });
              }}
              className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
              placeholder="Entrant/Topman "
            />
          </div>
        ))}
      </div>
      {users.length === 0 && (
        <div className="tw-text-center tw-text-gray-500 tw-py-8 tw-border tw-border-dashed tw-border-gray-300 tw-rounded-lg">
          <i className="pi pi-user tw-text-2xl tw-mb-2"></i>
          <p>{textToShow}</p>
        </div>
      )}
    </div>
  );
};

export default React.memo(PermitSignaturesComponent);
